
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MaintenancePage extends Vue {

  @Prop({ type: String, default: 'Service temporairement indisponible' }) readonly statusLabel!: string;

  @Prop({ type: String, default: 'Maintenance en cours' }) readonly eyebrow!: string;

  @Prop({ type: String, default: 'Nous améliorons notre site. De retour très bientôt !' }) readonly title!: string;

  @Prop({
    type: String,
    default: 'Une opération de maintenance est en cours pour vous offrir un service plus rapide et plus fiable. Merci de votre patience.',
  })
  readonly message!: string;

  @Prop({ type: String, default: "Aujourd'hui, vers 14h00" }) readonly eta!: string;

  @Prop({ type: String, default: 'Merci de votre compréhension.' }) readonly footer!: string;

  @Prop({ type: Boolean, default: true }) readonly showProgress!: boolean;

  year: number = new Date().getFullYear();
}
